var hide_empty_list = true; //uncomment this line to hide empty selection lists

var disable_empty_list = true; //uncomment this line to disable empty selection lists

addListGroup("courses", "Loc");

addOption("Loc", "Select Location ...", "", "", 1); //Empty starter option
addList("Loc", "Tampa", "2", "Tampa");
addList("Loc", "Orlando", "3", "Orlando");
addList("Loc", "Kissimmee", "4", "Kissimmee");
addList("Loc", "Tampa - en español", "8", "Tampa - en español");
addList("Loc", "Kissimmee - en español", "7", "Kissimmee - en español");
addList("Loc", "Live Virtual Classroom via MS Teams", "6", "Virtual");

addOption("Tampa", "Select Course ...", "", "", 1); // Empty starter option
addList("Tampa", "4 Hour BDI Class (Basic Course & TCAC)", "1", "tpa-1");
addList("Tampa", "4 Hour Under 25 Class (STOP or Youthful Offender)", "2", "tpa-2");
addList("Tampa", "Mature Defensive Driver for Insurance Discount Course", "8", "tpa-8");
addList("Tampa", "8 Hour Aggressive Driver Course", "4", "tpa-4");
addList("Tampa", "8 Hour DDS / Intermediate Course", "3", "tpa-3");
addList("Tampa", "8 Hour DWLS/R / FACT Course", "5", "tpa-5");
addList("Tampa", "12 Hour ADI Class (Advanced Driver Course)", "6", "tpa-6");
//* addList("Tampa", "4 Hour Drug and Alcohol Class (New Drivers)", "7", "tpa-7");

addOption("Tampa - en español", "Seleccione el curso...", "", "", 1); //Empty starter option
addList("Tampa - en español", "Clase de BDI de 4 horas (Curso básico y TCAC)", "1", "tpa-1es"); //4 Hour BDI Class (Basic Course & TCAC)
addList("Tampa - en español", "Clase de 4 horas para menores de 25 años", "2", "tpa-2es"); //4 Hour Under 25 Class (STOP or Youthful Offender)
addList("Tampa - en español", "Curso de 8 horas de DDS para curso básico o intermedio", "3", "tpa-3es"); //8 Hour DDS / DDC for Basic or Intermediate Course;
addList("Tampa - en español", "Curso de 8 horas para conductores agresivos", "4", "tpa-4es"); //8 Hour Aggressive Driver Class"
addList("Tampa - en español", "Curso de 8 horas de DWLS/R / FACT", "5", "tpa-5es"); //8 Hour DWLS / R / FACT Course
//* addList("Tampa - en español", "Clase de 12 horas de ADI (Curso de Conducción Avanzada)", "6", "tpa-6es"); //12 Hour ADI Class (Advanced Driver Course)
addList("Tampa - en español", "Clase de conductor defensivo maduro (descuento en seguros)", "8", "tpa-8es");

addOption("Orlando", "Select Course ...", "", "", 1); //Empty starter option
//* addList("Orlando", "4 Hour BDI Class (Basic Course & TCAC)", "1", "orl-1");
addList("Orlando", "4 Hour Under 25 Class (STOP or Youthful Offender)", "2", "orl-2");
addList("Orlando", "8 Hour Aggressive Driver Class", "4", "orl-4");
addList("Orlando", "8 Hour DDS/DDC for Basic or Intermediate Course", "3", "orl-3");
addList("Orlando", "8 Hour DWLS/R / FACT Course", "5", "orl-5");
//* addList("Orlando", "Mature Defensive Driver Course", "8", "orl-8");
//* addList("Orlando", "12 Hour ADI Class (Advanced Driver Course)", "6", "orl-6");

addOption("Kissimmee", "Select Course ...", "", "", 1); //Empty starter option
addList("Kissimmee", "4 Hour BDI Class (Basic Course & TCAC)", "1", "kis-1");
addList("Kissimmee", "4 Hour Under 25 Class (STOP or Youthful Offender)", "2", "kis-2");
addList("Kissimmee", "Mature Defensive Driver Class for Insurance Discount", "8", "kis-8");
addList("Kissimmee", "8 Hour DDS/DDC for Basic or Intermediate Course", "3", "kis-3");
addList("Kissimmee", "8 Hour Aggressive Driver Class", "4", "kis-4");
addList("Kissimmee", "8 Hour DWLS/R / FACT Course", "5", "kis-5");
//* addList("Kissimmee", "12 Hour ADI Class (Advanced Driver Course)", "6", "kis-6");

addOption("Kissimmee - en español", "Seleccione el curso...", "", "", 1); //Empty starter option
addList("Kissimmee - en español", "Clase de BDI de 4 horas (Curso básico y TCAC)", "1", "kis-1es"); //4 Hour BDI Class (Basic Course & TCAC)
addList("Kissimmee - en español", "Clase de 4 horas para menores de 25 años", "2", "kis-2es"); //4 Hour Under 25 Class (STOP or Youthful Offender)
//addList("Kissimmee - en español", "Curso de 8 horas de DDS/DDC para curso básico o intermedio", "3", "kis-3es"); //8 Hour DDS / DDC for Basic or Intermediate Course;
//addList("Kissimmee - en español", "Curso de 8 horas para Conductores Agresivos", "4", "kis-4es"); //8 Hour Aggressive Driver Class"
//addList("Kissimmee - en español", "Curso de 8 horas de DWLS/R / FACT", "5", "kis-5es"); //8 Hour DWLS / R / FACT Course
//addList("Kissimmee - en español", "Clase de 12 horas de ADI (Curso de Conducción Avanzada)", "6", "kis-6es"); //12 Hour ADI Class (Advanced Driver Course)
addList("Kissimmee - en español", "Clase de conductor defensivo maduro (descuento en seguros)", "8", "kis-8es");

addOption("Virtual", "Select Course ...", "", "", 1);
addList("Virtual", "4 Hour Under 25 Class (STOP or Youthful Offender)", "2", "vir-2");

//* ClassDates by Location and Course *//
/*
* When you want to set the start time of the class, use the following IDs for start times. For example, a 
* start time of 8am would be represented by the date and ID like `01/25/2025, 1`. As you can see, there
* are some start times that are represented by multiple IDs so be aware of that.
* 
* These IDs don't represent the full time span of the class. Instead, these IDs only represent the start time of 
* the class. We programatically handle setting the end time of the class when processing the registration based on 
* the type of class chosen.
* 
* These are hard-coded, so if something needs to change or a new start time is required, let Brian know so he can change
* it in the `LegacyRegistrationParser.cs` file.
* 
* Class Start Times by ID:
*   { startTime: 8:00am,  id: 1 }
* 
*   { startTime: 8:30am,  id: 6 }
*   { startTime: 8:30am,  id: 7 }
* 
*   { startTime: 9:00am,  id: 8 }
*   { startTime: 9:00am,  id: 9 }
* 
*   { startTime: 9:30am,  id: 4 }
*   { startTime: 9:30am,  id: 11 }
* 
*   { startTime: 10:00am, id: 3 }
* 
*   { startTime: 1:00pm,  id: 12 }
* 
*   { startTime: 6:15pm,  id: 10 }
* */

addOption("tpa-1", "Select Class Date ...", "", 1);//Empty starter option
addList("tpa-1", "Jul 12 -- (Registration Closed @ 4:30 pm)", "07/12/2025, 8", "r-10");
addList("tpa-1", "Jul 19 -- (Saturday from 9:30am-1:30pm)", "07/19/2025, 4", "r-1");
addList("tpa-1", "Jul 23 -- (Wednesday from 9:30am-1:30pm)", "07/23/2025, 4", "r-1");
addList("tpa-1", "Jul 26 -- (Saturday from 9:00am-1:00pm)", "07/26/2025, 8", "r-1");
addList("tpa-1", "Aug 2 -- (Saturday from 10:00am-2:00pm)", "08/02/2025, 3", "r-1");
addList("tpa-1", "Aug 9 -- (Saturday from 9:00am-1:00pm)", "08/09/2025, 8", "r-1");
addList("tpa-1", "Aug 16 -- (Saturday from 9:30am-1:30pm)", "08/16/2025, 4", "r-1");
addList("tpa-1", "Aug 20 -- (Wednesday from 10:00am-2:00pm)", "08/20/2025, 3", "r-1");

addOption("tpa-2", "Select Class Date ...", "", 1);//Empty starter option
addList("tpa-2", "Jul 12 -- (Registration Closed @ 4:30 pm)", "07/12/2025, 8", "r-10");
addList("tpa-2", "Jul 19 -- (Saturday from 9:30am-1:30pm)", "07/19/2025, 4", "r-2");
addList("tpa-2", "Jul 23 -- (Wednesday from 9:30am-1:30pm)", "07/23/2025, 4", "r-2");
addList("tpa-2", "Aug 2 -- (Saturday from 10:00am-2:00pm)", "08/02/2025, 3", "r-2");
addList("tpa-2", "Aug 9 -- (Saturday from 9:00am-1:00pm)", "08/09/2025, 8", "r-2");
addList("tpa-2", "Aug 16 -- (Saturday from 9:30am-1:30pm)", "08/16/2025, 4", "r-2");
addList("tpa-2", "Aug 20 -- (Wednesday from 10:00am-2:00pm)", "08/20/2025, 3", "r-2");

addOption("tpa-3", "Select Class Date ...", "", 1);//Empty starter option
addList("tpa-3", "Jul 12 -- (Registration Closed @ 4:30 pm)", "07/12/2025, 6", "r-10");
addList("tpa-3", "Jul 19 -- (Saturday from 9:00am-6:00pm)", "07/19/2025, 9", "r-3");
addList("tpa-3", "Jul 23 -- (Wednesday from 9:00am-6:00pm)", "07/23/2025, 9", "r-3");
addList("tpa-3", "Jul 26 -- (Saturday from 8:30am-5:30pm)", "07/26/2025, 6", "r-3");
addList("tpa-3", "Aug 2 -- (Saturday from 9:30am-6:30pm)", "08/02/2025, 11", "r-3");
addList("tpa-3", "Aug 16 -- (Saturday from 9:00am-6:00pm)", "08/16/2025, 9", "r-3");
addList("tpa-3", "Aug 20 -- (Wednesday from 9:30am-6:30pm)", "08/20/2025, 11", "r-3");

addOption("tpa-4", "Select Class Date ...", "", 1);//Empty starter option
addList("tpa-4", "Jul 12 -- (Registration Closed @ 4:30 pm)", "07/12/2025, 6", "r-10");
addList("tpa-4", "Jul 19 -- (Saturday from 9:00am-6:00pm)", "07/19/2025, 9", "r-4");
addList("tpa-4", "Jul 23 -- (Wednesday from 9:00am-6:00pm)", "07/23/2025, 9", "r-4");
addList("tpa-4", "Jul 26 -- (Saturday from 8:30am-5:30pm)", "07/26/2025, 6", "r-4");
addList("tpa-4", "Aug 2 -- (Saturday from 9:30am-6:30pm)", "08/02/2025, 11", "r-4");
addList("tpa-4", "Aug 9 -- (Saturday from 8:30am-5:30pm)", "08/09/2025, 6", "r-4");
addList("tpa-4", "Aug 16 -- (Saturday from 9:00am-6:00pm)", "08/16/2025, 9", "r-4");
addList("tpa-4", "Aug 20 -- (Wednesday from 9:30am-6:30pm)", "08/20/2025, 11", "r-4");

addOption("tpa-5", "Select Class Date ...", "", 1);//Empty starter option
addList("tpa-5", "Jul 19 -- (Saturday from 9:00am-6:00pm)", "07/19/2025, 9", "r-5");
addList("tpa-5", "Jul 23 -- (Wednesday from 9:00am-6:00pm)", "07/23/2025, 9", "r-5");
addList("tpa-5", "Jul 26 -- (Saturday from 8:30am-5:30pm)", "07/26/2025, 6", "r-5");
addList("tpa-5", "Jul 26 -- (Saturday from 8:30am-5:30pm)", "07/26/2025, 6", "r-5");
addList("tpa-5", "Aug 2 -- (Saturday from 9:30am-6:30pm)", "08/02/2025, 11", "r-5");
addList("tpa-5", "Aug 9 -- (Saturday from 8:30am-5:30pm)", "08/09/2025, 6", "r-5");
addList("tpa-5", "Aug 16 -- (Saturday from 9:00am-6:00pm)", "08/16/2025, 9", "r-5");
addList("tpa-5", "Aug 20 -- (Wednesday from 9:30am-6:30pm)", "08/20/2025, 11", "r-5");

addOption("tpa-6", "Select Class Date ...", "", 1);//Empty starter option
addList("tpa-6", "Jul 12 -- (Registration Closed @ 4:30 pm)", "07/12/2025, 7", "r-10");
addList("tpa-6", "Jul 26 -- (Saturday from 8:30am-8:30pm)", "07/26/2025, 7", "r-6");
addList("tpa-6", "Aug 9 -- (Saturday from 8:30am-8:30pm)", "08/09/2025, 7", "r-6");
addList("tpa-6", "Aug 23 -- (Saturday from 8:30am-8:30pm)", "08/23/2025, 7", "r-6");

addOption("tpa-8", "Select Class Date ...", "", 1);//Empty starter option
addList("tpa-8", "Jul 19 -- (Saturday from 9:30am-1:30pm)", "07/19/2025, 4", "r-8");
addList("tpa-8", "Jul 23 -- (Wednesday from 9:30am-1:30pm)", "07/23/2025, 4", "r-8");
addList("tpa-8", "Aug 2 -- (Saturday from 10:00am-2:00pm)", "08/02/2025, 3", "r-8");
addList("tpa-8", "Aug 16 -- (Saturday from 9:30am-1:30pm)", "08/16/2025, 4", "r-8");
addList("tpa-8", "Aug 20 -- (Wednesday from 10:00am-2:00pm)", "08/20/2025, 3", "r-8");


addOption("kis-1", "Select Class Date ...", "", 1);//Empty starter option
addList("kis-1", "Jul 13 -- (Sunday from 9:30am-1:30pm)", "07/13/2025, 4", "r-1");

addOption("kis-2", "Select Class Date ...", "", 1);//Empty starter option
addList("kis-2", "Jul 13 -- (Sunday from 9:30am-1:30pm)", "07/13/2025, 4", "r-2");

addOption("kis-3", "Select Class Date ...", "", 1);//Empty starter option
addList("kis-3", "Jul 13 -- (Sunday from 9:30am-6:30pm)", "07/13/2025, 11", "r-3");

addOption("kis-4", "Select Class Date ...", "", 1);//Empty starter option
addList("kis-4", "Jul 13 -- (Sunday from 9:30am-6:30pm)", "07/13/2025, 11", "r-4");

addOption("kis-5", "Select Class Date ...", "", 1);//Empty starter option
addList("kis-5", "Jul 13 -- (Sunday from 9:30am-6:30pm)", "07/13/2025, 11", "r-5");

addOption("kis-8", "Select Class Date ...", "", 1);//Empty starter option
addList("kis-8", "Jul 13 -- (Sunday from 9:30am-1:30pm)", "07/13/2025, 4", "r-8");


addOption("orl-2", "Select Class Date ...", "", 1);//Empty starter option
addList("orl-2", "Aug 2 -- (Saturday from 9:00am-1:00pm)", "08/02/2025, 8", "r-2");

addOption("orl-3", "Select Class Date ...", "", 1);//Empty starter option
addList("orl-3", "Aug 2 -- (Saturday from 9:00am-6:00pm)", "08/02/2025, 9", "r-3");

addOption("orl-4", "Select Class Date ...", "", 1);//Empty starter option
addList("orl-4", "Aug 2 -- (Saturday from 9:00am-6:00pm)", "08/02/2025, 9", "r-4");

addOption("orl-5", "Select Class Date ...", "", 1);//Empty starter option
addList("orl-5", "Aug 2 -- (Saturday from 9:00am-6:00pm)", "08/02/2025, 9", "r-5");


addOption("tpa-1es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("tpa-1es", "18 de junio -- (Cerradas - clase llena)", "06/18/2025, 4", "r-10es");

addOption("tpa-2es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("tpa-2es", "18 de junio -- (Cerradas - clase llena)", "06/18/2025, 4", "r-10es");

addOption("tpa-3es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("tpa-3es", "18 de junio -- (Cerradas - clase llena)", "06/18/2025, 11", "r-10es");

addOption("tpa-4es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("tpa-4es", "18 de junio -- (Cerradas - clase llena)", "06/18/2025, 11", "r-10es");

addOption("tpa-5es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("tpa-5es", "18 de junio -- (Cerradas - clase llena)", "06/18/2025, 11", "r-10es");

addOption("tpa-8es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("tpa-8es", "18 de junio -- (Cerradas - clase llena)", "06/18/2025, 4", "r-10es");


addOption("kis-1es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("kis-1es", "20 de agosto -- (Miércoles de 9:30am-1:30pm)", "08/20/2025, 4", "r-1es");

addOption("kis-2es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("kis-2es", "20 de agosto -- (Miércoles de 9:30am-1:30pm)", "08/20/2025, 4", "r-2es");

addOption("kis-8es", "Seleccione la fecha de la clase ...", "", 1);//Empty starter option
addList("kis-8es", "20 de agosto -- (Miércoles de 9:30am-1:30pm)", "08/20/2025, 4", "r-8es");


addOption("vir-2", "Select Class Date ...", "", 1);//Empty starter option
addList("vir-2", "Jun 12 -- (Closed - Class Full)", "06/12/2025, 12", "r-10");
addList("vir-2", "Aug 14 -- (Thursday from 1:00pm-5:00pm)", "08/14/2025, 12", "r-2");

//* End ClassDates by Location and Course *//


addOption("r-1", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-1", "Election for Traffic Ticket (No Points)", "BDI - Election for Traffic Ticket");
addList("r-1", "Court Order - 4 Hour Defensive Driving Course", "BDI - Court Ordered");
addList("r-1", "Employer Required - 4 Hour Defensive Driving Class", "BDI - Employer Requirement");
addList("r-1", " ", "");
addList("r-1", "Court Order - 4 Hour Traffic Collision Avoidance Class", "BDI - TCAC Court Ordered");
addList("r-1", "DMV Letter for Traffic Collision Avoidance Class (TCAC)", "BDI - DMV Order for TCAC");
addList("r-1", " ", "");
addList("r-1", "DMV Letter for Traffic Signal Violation", " BDI - Running Red Light");
addList("r-1", "DMV Letter for Reckless Driving", "BDI - Reckless Driving");
addList("r-1", "DMV Letter for Passing School Bus", "BDI - Passing School Bus");
addList("r-1", "DMV Letter for Highway Racing", "BDI - Highway Racing");
addList("r-1", "DMV Letter for Highway Racing Spectator", "BDI - Highway Racing Spectator");
//* addOption("r-1", "Insurance Discount for Mature Driver (55+ Years Old)", "BDI - Mature Driver Insurance Discount"); 

addOption("r-2", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-2", "Court Order - Complete Under 25 DDC", "Court Ordered (Under 25 Defensive Driver School)");
//* addOption("r-2", "Election - Personal Education", "Personal Election (Under 25 Defensive Driver School)"); 

addOption("r-3", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-3", "Court Order - 8 Hour DDS / Intermediate Course", "8 Hour DDS/Intermediate - Court Ordered");
addList("r-3", "Pre-Trial Plea - 8 Hour Defensive Driving Course (DDC)", "8 Hour DDS/Intermediate - Pre-Trial");
addList("r-3", "Employer Required - 8 Hour Defensive Driving Course (DDC)", "8 Hour DDS/Intermediate - Employer Required");

addOption("r-4", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-4", "Court Order - 8 Hour Aggressive Driver Course", "8 Hour Aggressive Driver - Court Ordered");
addList("r-4", "Pre-Trial - 8 Hour Aggressive Driver Course", "8 Hour Aggressive Driver - Pre-Trial");
addList("r-4", "Employer Requirement - 8 Hour Aggressive Driver Course", "8 Hour Aggressive Driver - Employer Required");

addOption("r-5", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-5", "Court Order for Driving on Suspended License Course", "8 Hour DWLS/R - Court Ordered");

addOption("r-6", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-6", "Court Ordered by a Judge - 12 Hour Advanced Course", "12 Hour ADI - Court Ordered");
addList("r-6", " ", "");
addList("r-6", "DMV Hardship License or HTO Hearing - 12 Hour ADI Class", "Florida DMV Requirement for HTO Hardship Request");
addList("r-6", "DMV Points Suspension - 12 Hour ADI Class", "Florida DMV Requirement Points Suspension");
addList("r-6", " ", "");
addList("r-6", "Florida DMV Requirement for 3 Collisions in 3 Years", "Florida DMV Requirement for 3 Collisions in 3 Years");
addList("r-6", " ", "");
addList("r-6", "Employer Required", "12 Hour ADI - Employer/Business Purpose");

addOption("r-8", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-8", "Mature Driver Insurance Discount (55+ Years Old)", "Insurance Discount");

addOption("r-10", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-10", " Class Full - Please select another date or location", "");

addOption("r-12", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-12", "To Be Determined - Please Check Back Later", "TBD");

addOption("r-11", "Select why you need to take class ...", "", "", 1); //Empty starter option
addList("r-11", "Walk-Ins must arrive NLT 20 min before class with ALL Paperwork", "WalkIn");

//* addOption("r-9", "** Select Reason **", "", "", 1); //Empty starter option
//* addOption("r-9", "Select Tampa -- or attend Online Class", "");

//* addOption("r-7", "** Select Reason **", "", "", 1); //Empty starter option
//* addOption("r-7", "4 Hour TLSAE Course for First Time Drivers & Learners Permit", "TLSAE Course for First Time Drivers/Learners Permit");


// SPANISH REASONS \\
addOption("r-1es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-1es", "Elección por multa de tráfico (sin puntos)", "BDI - Election for Traffic Ticket");
addList("r-1es", "Orden judicial - Curso de conducción defensiva de 4 horas", "BDI - Court Ordered");
addList("r-1es", "Requisito del empleador - Clase de conducción defensiva de 4 horas", "BDI - Employer Requirement");
addList("r-1es", " ", "");
addList("r-1es", "Orden judicial - Curso para evitar colisiones de tráfico (TCAC)", "BDI - TCAC Court Ordered");
addList("r-1es", "Carta del DMV para completar el curso para evitar colisiones de tránsito (TCAC)", "BDI - DMV Order for TCAC");
addList("r-1es", " ", "");
addList("r-1es", "Carta del DMV por violación de señal de tráfico", "BDI - Running Red Light");
addList("r-1es", "Carta del DMV por conducción temeraria", "BDI - Reckless Driving");
addList("r-1es", "Carta del DMV por pasar un autobús escolar", "BDI - Passing School Bus");
addList("r-1es", "Carta del DMV por carreras en la autopista", "BDI - Highway Racing");
addList("r-1es", "Carta del DMV por espectador de carreras en la autopista", "BDI - Highway Racing Spectator");
//* addOption("r-1es", "Descuento de Seguro para conductor maduro (55+ años)", "BDI - Mature Driver Insurance Discount");
//* addOption("r-1es", " ", "");

addOption("r-2es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-2es", "Orden judicial - completar DDC para menores de 25 años", "Court Ordered (Under 25 Defensive Driver School)");
//* addOption("r-2es", "Elección - Educación Personal", "Personal Election (Under 25 Defensive Driver School)"); 

addOption("r-3es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-3es", "Orden judicial - Curso intermedio DDS de 8 horas", "8 Hour DDS/Intermediate - Court Ordered");
addList("r-3es", "Acuerdo previo al juicio - Curso de conducción defensiva de 8 horas (DDC)", "8 Hour DDS/Intermediate - Pre-Trial");
addList("r-3es", "Requisito del empleador - Curso de conducción defensiva de 8 horas (DDC)", "8 Hour DDS/Intermediate - Employer Required");

addOption("r-4es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-4es", "Orden judicial - Curso para conductores agresivos de 8 horas", "8 Hour Aggressive Driver - Court Ordered");
addList("r-4es", "Acuerdo previo al juicio - Curso para conductores agresivos de 8 horas", "8 Hour Aggressive Driver - Pre-Trial");
addList("r-4es", "Requisito del empleador - Curso para conductores agresivos de 8 horas", "8 Hour Aggressive Driver - Employer Required");

addOption("r-5es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-5es", "Orden judicial para curso por conducir con licencia suspendida", "8 Hour DWLS/R - Court Ordered");

addOption("r-6es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-6es", "Orden judicial por un juez - Curso avanzado de 12 horas", "12 Hour ADI - Court Ordered");
addList("r-6es", " ", "");
addList("r-6es", "Licencia por necesidad o audiencia HTO del DMV - Clase ADI de 12 horas", "Florida DMV Requirement for HTO Hardship Request");
addList("r-6es", "Suspensión de puntos del DMV - Clase ADI de 12 horas", "Florida DMV Requirement Points Suspension");
addList("r-6es", " ", "");
addList("r-6es", "Requisito del DMV de Florida por 3 colisiones en 3 años", "Florida DMV Requirement for 3 Collisions in 3 Years");
addList("r-6es", " ", "");
addList("r-6es", "Requisito del empleador", "12 Hour ADI - Employer/Business Purpose");

addOption("r-8es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-8es", "Descuento de seguro para conductor maduro (55+ años)", "Insurance Discount");

addOption("r-10es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-10es", "Clase llena - Por favor seleccione otra fecha", "");

addOption("r-12es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-12es", "Por Determinar - Por favor vuelva más tarde", "TBD");

addOption("r-11es", "Seleccione por qué necesita tomar la clase ...", "", "", 1); //Empty starter option
addList("r-11es", "Los que lleguen sin cita deben llegar a más tardar 20 minutos antes de la clase con TODOS los Documentos", "WalkIn");

